import React, { useEffect } from 'react';
import { Watermark, showBlindWatermark } from 'design-system';

import watermarkLogo from 'src/assets/images/watermarkLogo.png';

import { User } from '../../services/user';
import { getUserFullName } from '../../utils';
import { useAuthContext } from '../../auth/hooks';

interface WatermarkContentProps {
  children?: React.ReactNode;
}

const WatermarkWrap = ({ children }: WatermarkContentProps) => {
  const { user } = useAuthContext();
  useEffect(() => {
    showBlindWatermark(`${getUserFullName(user as User)}-${user?.id || ''}`);
  }, [user]);

  return (
    <Watermark zIndex={1} image={watermarkLogo} width={34} height={34}>
      {children}
    </Watermark>
  );
};

export default WatermarkWrap;
